import React from 'react'

export const Header: React.FC = () => (
  <div className='header'>
    <h1>Perfect product quiz</h1>
    <p>Answer simple questions about your experience to receive a personalized selection of industry-leading bladder control products with a special offer</p>
  </div>
)
